import { render, staticRenderFns } from "./statisticsChart.vue?vue&type=template&id=c971d5f6&scoped=true&"
import script from "./statisticsChart.vue?vue&type=script&lang=js&"
export * from "./statisticsChart.vue?vue&type=script&lang=js&"
import style0 from "./statisticsChart.vue?vue&type=style&index=0&id=c971d5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971d5f6",
  null
  
)

export default component.exports